// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useTranslation } from "react-i18next";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface TimezoneCellProps {
  timeZone: string;
}

export function TimezoneCell({ timeZone }: TimezoneCellProps) {
  const { i18n } = useTranslation();
  const now = new Date();
  const tzDate = new Date(now.toLocaleString("en-US", { timeZone }));
  const utcDate = new Date(now.toLocaleString("en-US", { timeZone: "UTC" }));
  const diffMinutes = Math.round((tzDate.getTime() - utcDate.getTime()) / 60000);
  const h = Math.trunc(diffMinutes / 60);
  const utcOffset = `UTC${h >= 0 ? "+" : "-"}${String(Math.abs(h)).padStart(2, "0")}`;
  const formatted = new Intl.DateTimeFormat(i18n.language, {
    timeZone,
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(now);
  const capitalized = formatted.charAt(0).toUpperCase() + formatted.slice(1);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-help underline decoration-dotted underline-offset-2">{timeZone}</span>
      </TooltipTrigger>
      <TooltipContent side="right">{`${utcOffset} | ${capitalized}`}</TooltipContent>
    </Tooltip>
  );
}
